module.exports = __webpack_public_path__ + "static/img/4.e8f0ba9.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner1/4.png
// module id = s42Q
// module chunks = 14